
import React from 'react';
import Navbar from '../components/Navbar';
import AnimatedBackground from '../components/AnimatedBackground';

const License = () => {
  return (
    <div className="min-h-screen w-full overflow-hidden">
      <AnimatedBackground />
      <Navbar />
      
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-4xl mx-auto bg-black/50 backdrop-blur-lg rounded-xl p-8 border border-white/10 text-left">
          <h1 className="text-3xl font-bold mb-8 text-white">License Terms and Intellectual Property</h1>
          <p className="text-gray-300 mb-4">Last updated: March 31, 2025</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-6">
              The intellectual and industrial property rights over the Cloudima platform, its code, design, functionalities, and brand belong exclusively to the Cloudima development team, unless expressly stated otherwise.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. User License</h2>
            <p className="text-gray-300 mb-4">
              The user obtains a limited, non-exclusive, and non-transferable license to use Cloudima according to these terms and only for legal and professional purposes.
            </p>
            <p className="text-gray-300 mb-4">
              The following is not permitted:
            </p>
            <ul className="list-disc pl-6 text-gray-300 mb-6 space-y-2">
              <li>Modifying, copying, distributing, or reverse engineering the software</li>
              <li>Using the platform to offer similar services, replicate functionality, or create a derivative product</li>
              <li>Sharing access credentials with third parties</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. User-Generated Content</h2>
            <p className="text-gray-300 mb-4">
              The user retains all rights over architectures designed, images generated, and Terraform code exported from the platform.
            </p>
            <p className="text-gray-300 mb-4">
              However, when using Cloudima, the user grants a non-exclusive license to:
            </p>
            <ul className="list-disc pl-6 text-gray-300 mb-6 space-y-2">
              <li>Process, display, and share their content within their organization</li>
              <li>Share it publicly if the user so indicates through platform options</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Use of Templates and Modules</h2>
            <p className="text-gray-300 mb-4">
              Some visual modules or templates offered by Cloudima may be under free or commercial licenses. In that case, the associated license will be expressly indicated and must be respected.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Trademarks and Logos</h2>
            <p className="text-gray-300 mb-4">
              All logos, trademarks, trade names, and distinctive elements related to Cloudima are protected and may not be used without express authorization.
            </p>
          </div>
        </div>
      </div>
      
      <footer className="py-8 border-t border-gray-700/30 relative z-10 bg-black/30 backdrop-blur-sm">
        <div className="container px-4 mx-auto">
          <div className="mt-4 text-center">
            <span className="text-sm text-gray-400">© {new Date().getFullYear()} Cloudima. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default License;
